<script setup lang="ts">
const contactsStore = useMyContactsStore()
const { contacts } = storeToRefs(contactsStore)
</script>

<template>
  <section id="contact" class="px-1 py-8 md:py-12">
    <h2 data-reveal class="text-2xl font-extrabold md:text-3xl">
      <span class="text-accent">تماس</span> با من
    </h2>
    <p data-reveal class="mt-3 max-w-lg text-sm leading-8 text-muted">
      برای شروع همکاری یک ایمیل بفرستید یا در شبکه‌های اجتماعی با من در ارتباط باشید.
    </p>

    <ul class="mt-6 grid list-none gap-2.5 p-0 sm:grid-cols-2 lg:grid-cols-3">
      <li v-for="contact in contacts" :key="contact.id">
        <a
          :href="contact.href"
          :target="contact.external ? '_blank' : undefined"
          :rel="contact.external ? 'noopener noreferrer' : undefined"
          data-reveal
          class="flex items-center gap-3 rounded-xl border border-line bg-surface-2 p-3.5 text-ink transition hover:-translate-y-0.5 hover:border-accent"
        >
          <span class="grid h-[38px] w-[38px] shrink-0 place-content-center rounded-[10px] border border-line bg-surface text-accent">
            <SharedContactIcon :kind="contact.icon" class="h-[18px] w-[18px]" />
          </span>
          <span class="grid min-w-0 gap-0.5">
            <span
              class="text-muted"
              :class="contact.displayValue ? 'text-[11px]' : 'text-[13px] font-semibold'"
            >
              {{ contact.key }}
            </span>
            <span
              v-if="contact.displayValue"
              class="break-all text-[13px] font-semibold"
            >
              {{ contact.displayValue }}
            </span>
          </span>
        </a>
      </li>
    </ul>
  </section>
</template>
